import Vue from 'vue';
import I18n from 'vue-i18n';
import messages from "@/lang";

Vue.use(I18n);

export default new I18n({
    locale: 'pl',
    fallbackLocale: 'de',
    messages
})